import DocumentApi from "@/api/document";

export default class Document {
  constructor() {

  }

  upload = (tokenAuth, documentList) => {
    return DocumentApi.upload(tokenAuth, documentList).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  }

  uploadRenounceSavingDocuments = (tokenAuth, id, documentList) => {
    return DocumentApi.uploadRenounceSavingDocuments(tokenAuth, id, documentList).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  }

  getDocumentsType = (tokenAuth) => {
    return DocumentApi.getDocumentsType(tokenAuth).then(response => {
      return response
    }).catch(error => {
      throw error;
    });
  }

  getFileByIdSelector = (selector) => {
    document.getElementById(selector).value = "";
    document.getElementById(selector).click();
  }

  serialize = (file) => {
    const fileReader = new FileReader();
    
    return new Promise((resolve, reject) => {
      fileReader.onload = (fileEvent) => {
        let fileBase64 = fileEvent.target.result.split(',')[1];
        resolve(fileBase64);
      }

      fileReader.onerror = () => {
        reject('error, something went wrong with the file reader.')
      }

      fileReader.readAsDataURL(file);
    });
  }

  getDocumentsRequired = (tokenAuth, requeriedIn) => {
    return DocumentApi.getDocumentsRequired(tokenAuth, requeriedIn).then(response => {
      return response
    }).catch(error => {
      throw error;
    });
  }

  getRetirementDocumentsAttached = (tokenAuth, retirementId) => {
    return DocumentApi.getRetirementDocumentsAttached(tokenAuth, retirementId).then(response => {
      return response
    }).catch(error => {
      throw error;
    });
  }

  getRefundDocumentsAttached = (tokenAuth, retirementId) => {
    return DocumentApi.getRefundDocumentsAttached(tokenAuth, retirementId).then(response => {
      return response
    }).catch(error => {
      throw error;
    });
  }

  getSavingDocumentsAttached = (tokenAuth, savingId) => {
    return DocumentApi.getSavingDocumentsAttached(tokenAuth, savingId).then(response => {
      return response
    }).catch(error => {
      throw error;
    });
  }
}